import React, { Component, useState, useEffect } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  Image,
  Text,
  Keyboard,
  Vibration,
  View,
  Alert,
} from "react-native";

function range(start, end) {
  return Array.from({ length: end - start + 1 }, (_, i) => i).slice(start, end);
}

const getCurrentSelectionDays = (currentSelection) => {
  const days = new Date(
    currentSelection.getFullYear(),
    currentSelection.getMonth() - 1,
    0
  ).getDate();
  return range(1, days + 1);
};

const getCurrentSelectionOffset = (currentSelection) => {
  const days =
    new Date(
      currentSelection.getFullYear(),
      new Date(currentSelection).getMonth(),
      1
    ).getDay() -
      1 <
    0
      ? 6
      : new Date(
          currentSelection.getFullYear(),
          currentSelection.getMonth(),
          1
        ).getDay() - 1;
  return range(0, days);
};

export default function (props) {
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const [hoy] = useState(new Date(Date.now()));
  const [currentSelection, setCurrentSelection] = useState(
    new Date(
      new Date(Date.now()).getFullYear(),
      new Date(Date.now()).getMonth(),
      1
    )
  );
  const [currentSelectedDay, setCurrentSelectedDay] = useState(null);
  const isDayDisabled = (day, yearMonth) => {
    if (
      props.maxDate &&
      new Date(yearMonth.getFullYear(), yearMonth.getMonth(), day + 1) >
        props.maxDate
    )
      return true;
    if (
      props.minDate &&
      new Date(yearMonth.getFullYear(), yearMonth.getMonth(), day + 1) <
        props.minDate
    )
      return true;
  };

  const addMonth = () => {
    setCurrentSelection(
      new Date(
        currentSelection.getFullYear(),
        currentSelection.getMonth() + 1,
        1
      )
    );
  };
  const substractMonth = () => {
    setCurrentSelection(
      new Date(
        currentSelection.getFullYear(),
        currentSelection.getMonth() - 1,
        1
      )
    );
  };
  const styles = StyleSheet.create({
    ...props.style,
    headerContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    headerDay: {
      width: "14%",
      fontFamily: "Montserrat-Regular",
      color: "#4C686F",
      fontSize: 12,
      fontWeight: "bold",
      textAlign: "center",
      lineHeight: 38,
    },
    daysContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
    },
    dayButton: {
      width: "14%",
      height: 40,
      alignItems: "center",
      justifyContent: "center",
    },
    day: {
      fontFamily: "Montserrat-Regular",
      color: "#3E4672",
      fontWeight: "500",
      fontSize: 15,
      textAlign: "center",
      lineHeight: 38,
    },
    container: {
      alignSelf: "center",
      width: 400,
      maxWidth: "90%",
      backgroundColor: "#FFFFFF",
      padding: 15,
      borderRadius: 30,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.2,
      shadowRadius: 1.41,
      elevation: 2,
    },
    month: {
      alignSelf: "center",
      fontFamily: "Nunito-Bold",
      textTransform: "capitalize",
      fontSize: 22,
      color: "#3E4672",
    },
    arrow: {
      height: 24,
      width: 24,
    },
    disabled: {
      fontFamily: "Montserrat-Regular",
      fontWeight: "bold",
      color: "grey",
    },
  });

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        {currentSelection > props.minDate || !props.minDate ? (
          <TouchableOpacity
            onPress={substractMonth}
            style={{ width: 50, height: 50, justifyContent: "center" }}>
            <Image
              style={{
                width: 24,
                height: 24,

                marginLeft: 20,
                transform: [{ rotate: "180deg" }],
              }}
              source={require("../assets/images/arrow.png")}
            />
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={substractMonth}
            style={{ width: 50, height: 50, justifyContent: "center" }}
            disabled>
            <Image
              style={{
                width: 24,
                height: 24,
                marginLeft: 20,
                transform: [{ rotate: "180deg" }],
                opacity: 0.2,
              }}
              source={require("../assets/images/arrow.png")}
            />
          </TouchableOpacity>
        )}
        <Text style={styles.month}>
          {meses[new Date(currentSelection).getMonth()]}
        </Text>
        {new Date(
          currentSelection.getFullYear(),
          currentSelection.getMonth() + 1,
          currentSelection.getDate()
        ) < new Date(props.maxDate) || !props.maxDate ? (
          <TouchableOpacity
            onPress={addMonth}
            style={{ width: 50, height: 50, justifyContent: "center" }}>
            <Image
              style={{ width: 24, height: 24, marginRight: 20 }}
              source={require("../assets/images/arrow.png")}
            />
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={addMonth}
            style={{ width: 50, height: 50, justifyContent: "center" }}
            disabled>
            <Image
              style={{
                width: 24,
                height: 24,
                marginRight: 20,
                opacity: 0.2,
              }}
              source={require("../assets/images/arrow.png")}
            />
          </TouchableOpacity>
        )}
      </View>
      <View style={styles.daysContainer}>
        <Text style={styles.headerDay}>LUN</Text>
        <Text style={styles.headerDay}>MAR</Text>
        <Text style={styles.headerDay}>MIE</Text>
        <Text style={styles.headerDay}>JUE</Text>
        <Text style={styles.headerDay}>VIE</Text>
        <Text style={styles.headerDay}>SAB</Text>
        <Text style={styles.headerDay}>DOM</Text>
        {getCurrentSelectionOffset(currentSelection).map((offset) => (
          <View key={offset} style={{ width: "14%" }}></View>
        ))}
        {getCurrentSelectionDays(currentSelection).map((day) => {
          let isToday = {};
          if (
            currentSelection.getFullYear() +
              "" +
              currentSelection.getMonth() +
              "" +
              day ==
            new Date(Date.now()).getFullYear() +
              "" +
              new Date(Date.now()).getMonth() +
              "" +
              new Date(Date.now()).getDate()
          ) {
            isToday = { color: "#3092a1" };
          }
          let isSelected = {};
          if (
            currentSelectedDay &&
            currentSelection.getFullYear() +
              "" +
              currentSelection.getMonth() +
              "" +
              day ==
              currentSelectedDay.getFullYear() +
                "" +
                currentSelectedDay.getMonth() +
                "" +
                currentSelectedDay.getDate()
          ) {
            isSelected = { color: "#fac411", fontSize: 17 };
          }
          return (
            <TouchableOpacity
              key={day}
              style={styles.dayButton}
              disabled={isDayDisabled(day, currentSelection)}
              onPress={() => {
                setCurrentSelectedDay(
                  new Date(
                    currentSelection.getFullYear(),
                    currentSelection.getMonth(),
                    day,
                    0,
                    0
                  )
                );
                props.onChange(
                  new Date(
                    currentSelection.getFullYear(),
                    currentSelection.getMonth(),
                    day,
                    0,
                    0
                  )
                );
              }}>
              {isDayDisabled(day, currentSelection) ? (
                <Text
                  key={day}
                  style={{
                    fontFamily: "Montserrat-Regular",
                    color: "#3E4672",
                    fontWeight: "500",
                    fontSize: 15,
                    textAlign: "center",
                    lineHeight: 38,
                    color: "grey",
                    ...isToday,
                  }}>
                  {day}
                </Text>
              ) : (
                <Text
                  key={day}
                  style={{ ...styles.day, ...isToday, ...isSelected }}>
                  {day}
                </Text>
              )}
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}
